window.addEventListener('scroll', toggleHideDropdown);
window.addEventListener('load', toggleHideDropdown);

function toggleHideDropdown() {
    var siteHeader = document.querySelector('.site-header');
    var shopifyCrossBorder = document.querySelector('.shopify-cross-border');

    if (siteHeader && shopifyCrossBorder) {
        if (siteHeader.classList.contains('site-header-sticky--scrolled')) {
            shopifyCrossBorder.classList.add('hide-dropdown');
        } else {
            shopifyCrossBorder.classList.remove('hide-dropdown');
        }
    }
}
